import React from "react";
import MatrixOSInfoShell from "./MatrixOSInfoShell";

const faqItems = [
  {
    q: "What is MatrixOS?",
    a: "MatrixOS is an operational intelligence platform for multi-site businesses. It sits above the systems already running the business and connects workforce, inventory, movement, response, and site-level execution into one operational layer.",
  },
  {
    q: "What does Neo do?",
    a: "Neo is the workforce operations layer. It connects published schedules with actual attendance, duties, exceptions, management decisions, reports, and Response Intelligence. Supported workflows can also send WhatsApp reminders and escalations to the right people.",
  },
  {
    q: "What does Morpheus do?",
    a: "Morpheus is the inventory intelligence layer. It prepares inventory for counting, runs physical count sessions, records section ownership, supports verification, calculates variance and financial exposure, and gives operators a multi-site view of count activity and response needs.",
  },
  {
    q: "What does Link do?",
    a: "Link is the movement and execution layer for dispatch, queues, handoffs, and delivery workflows. It remains in active development, so availability and final workflows may differ until the product is released more broadly.",
  },
  {
    q: "What is Matrix League?",
    a: "Matrix League is the performance competition layer. It supports seasons, divisions, standings and events, and is designed to turn trusted operational results from MatrixOS into visible league points and team competition where scoring integrations are enabled.",
  },
  {
    q: "Can we start with only one layer?",
    a: "Yes. A business can start with the layer that solves the biggest operational problem first and add other layers as the rollout grows.",
  },
  {
    q: "Does MatrixOS replace our POS or payroll system?",
    a: "No. MatrixOS is designed to sit above systems of record rather than replace them. Integration availability depends on the data, APIs, exports, permissions, and access made available by each external provider.",
  },
  {
    q: "Can MatrixOS work across multiple sites?",
    a: "Yes. Multi-site operations are a core use case. MatrixOS is designed to give owners, regional managers, and operating teams clearer visibility across locations while each site keeps its own operational context.",
  },
  {
    q: "How is access controlled?",
    a: "Access can be scoped by organization, product layer, role, site, profile, manager permissions, linked device, and user access. The goal is that each person only sees and controls what they are authorized to use.",
  },
  {
    q: "How does Response Intelligence work?",
    a: "Response Intelligence turns operational exceptions into action. Depending on the workflow, MatrixOS can surface the issue, notify the responsible person, escalate if it remains unresolved, capture a manager decision, and preserve the response history.",
  },
  {
    q: "Can MatrixOS send WhatsApp or email alerts?",
    a: "Where configured and supported, yes. Neo can use approved WhatsApp templates for operational reminders and escalations, while Morpheus can use supported alert channels such as email. Delivery still depends on valid recipients and the relevant third-party provider.",
  },
  {
    q: "Is our data safe?",
    a: "No system can promise zero risk, but MatrixOS is designed around scoped access, cloud-hosted controls, linked-device management, audit history, and permission checks. Customers must also protect credentials, devices, and internal access procedures.",
  },
  {
    q: "Can we book a Discovery before committing?",
    a: "Yes. A Discovery is the best starting point if you want to discuss your current systems, operating pain points, and which MatrixOS layer is most relevant before considering rollout.",
  },
  {
    q: "Is Contact the same as Book a Discovery?",
    a: "They serve different intents. Book a Discovery is for a guided product and operations conversation; the Contact page also handles support, billing, privacy, partnerships, account questions and general enquiries.",
  },
];

export default function Faq() {
  return (
    <MatrixOSInfoShell
      eyebrow="FAQ"
      title="Questions operators usually ask first."
      subtitle="A current view of MatrixOS, its product layers, integrations, response workflows, access, security, and rollout."
    >
      <div style={styles.grid}>
        {faqItems.map((item) => (
          <article key={item.q} className="matrixos-glow-card" style={styles.card}>
            <div style={styles.question}>{item.q}</div>
            <div style={styles.answer}>{item.a}</div>
          </article>
        ))}
      </div>
    </MatrixOSInfoShell>
  );
}

const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: 18,
  },
  card: {
    padding: "24px 26px",
    borderRadius: 24,
    background: "linear-gradient(180deg, rgba(9,30,52,0.82) 0%, rgba(4,14,27,0.94) 100%)",
    border: "1px solid rgba(99, 229, 255, 0.15)",
    boxShadow: "0 18px 70px rgba(0,0,0,0.16)",
  },
  question: {
    fontSize: "1.38rem",
    fontWeight: 950,
    letterSpacing: "-0.035em",
    marginBottom: 10,
    color: "#ffffff",
  },
  answer: {
    color: "#d2e7f2",
    lineHeight: 1.78,
    fontSize: "1rem",
  },
};
